import { StandardSelector } from "lib/@components/combos/standard-selector"
import { useSearchParam } from "lib/@hooks/use-search-param"
import {
    getAssetProfileScopeLabel,
    PROFILE_SCOPE_LOCATION_ONLY,
    PROFILE_SCOPE_SEARCH_PARAM,
    PROFILE_SCOPE_WITH_CHILDREN,
    normaliseAssetProfileScope,
} from "routes/asset-profile/asset-profile-scope"
import Iconify from "minimals-template/components/Iconify"

const scopeOptions = [
    { value: PROFILE_SCOPE_WITH_CHILDREN, label: getAssetProfileScopeLabel(PROFILE_SCOPE_WITH_CHILDREN) },
    { value: PROFILE_SCOPE_LOCATION_ONLY, label: getAssetProfileScopeLabel(PROFILE_SCOPE_LOCATION_ONLY) },
]

export function AssetProfileScopeToggle() {
    const [scope, setScope] = useSearchParam(PROFILE_SCOPE_SEARCH_PARAM, PROFILE_SCOPE_WITH_CHILDREN)
    const value = normaliseAssetProfileScope(scope)

    return (
        <StandardSelector
            size="small"
            color="primary"
            value={value}
            options={scopeOptions}
            onChange={setScope}
            startIcon={<Iconify icon="streamline:location-target-1-solid" />}
            data-cy="asset-profile-scope-toggle"
            optionSx={{ fontSize: 13 }}
            sx={{ flexShrink: 0, whiteSpace: "nowrap" }}
        />
    )
}
